'use client';

import { logFromServer } from 'actions/DevTools';

const DevLogTesting = () => {
  const clientLog = () => {
    // eslint-disable-next-line no-console
    console.log('Error from the Dev Tools');
  };

  const clientError = () => {
    throw new Error('Error from the Dev Tools');
  };

  const serverLog = async () => {
    await logFromServer();
  };

  return (
    <section>
      <h3>Log Testing</h3>

      <div className="layout-row">
        <button
          onClick={() => {
            clientLog();
          }}
        >
          Client Log
        </button>
        <button
          onClick={() => {
            clientError();
          }}
        >
          Client Error
        </button>
        <button
          onClick={() => {
            serverLog();
          }}
        >
          Server Log
        </button>
      </div>
    </section>
  );
};

export default DevLogTesting;
